import "./adyen-card-provider";
import "./register";
